import {
  getAuth,
  GoogleAuthProvider,
  FacebookAuthProvider,
  OAuthProvider,
  Auth,
} from "firebase/auth";
import app, { hasConfig } from "./app-core";

let auth: Auth | undefined;
let googleProvider: GoogleAuthProvider | undefined;
let facebookProvider: FacebookAuthProvider | undefined;
let appleProvider: OAuthProvider | undefined;

if (hasConfig && app) {
  auth = getAuth(app);
  googleProvider = new GoogleAuthProvider();
  facebookProvider = new FacebookAuthProvider();
  facebookProvider.addScope("email");
  facebookProvider.setCustomParameters({ display: "popup" });
  appleProvider = new OAuthProvider("apple.com");
  appleProvider.addScope("email");
  appleProvider.addScope("name");
}

export { auth, googleProvider, facebookProvider, appleProvider };
